import { ValidationRegexs } from '@/types/validation-regexs';
import { UNIT_TRANSLATIONS } from '@/app/(pdp)/constants';
import { cn } from '@/utils/cn';
interface Props {
  value: number;
  unit: string;
  className?: string;
}
const WeightDisplay = ({
  value,
  unit,
  className
}: Props) => {
  const lowerCaseUnit = unit.toLowerCase();
  const displayUnit = Object.hasOwn(UNIT_TRANSLATIONS, lowerCaseUnit) ? UNIT_TRANSLATIONS[lowerCaseUnit] : unit;
  const isUnitPersian = ValidationRegexs.persianArabicCharacters.test(displayUnit);
  return <span className={cn(className, {
    'right-to-left inline-block': isUnitPersian
  })} data-sentry-component="WeightDisplay" data-sentry-source-file="weight-display.tsx">
            {value} {displayUnit}
        </span>;
};
export default WeightDisplay;